module.exports = __webpack_public_path__ + "components/country-flag/static/mn-8a8c1fb57b069f4c01c0d843f37683e5.svg";